import { render, staticRenderFns } from "./genericsitetypemodal.vue?vue&type=template&id=20211284&scoped=true"
import script from "./genericsitetypemodal.vue?vue&type=script&lang=js"
export * from "./genericsitetypemodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20211284",
  null
  
)

export default component.exports